import { IonContent, IonPage, IonFab, IonFabButton, IonButton, IonLabel, IonItem, IonIcon, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCardContent, IonModal, IonInfiniteScroll, IonInfiniteScrollContent, IonAlert, IonHeader, IonToolbar, IonButtons, IonTitle, IonGrid, IonRow, IonCol, IonRefresher, IonRefresherContent, useIonAlert, useIonToast, IonLoading, IonSelect, IonSelectOption, IonCheckbox, IonItemDivider, useIonViewWillEnter } from '@ionic/react';
import React, { useState } from 'react';
import { add, call, documentLock, idCard, mail, people, remove, storefront, trash } from 'ionicons/icons';
import './Equipe.css';
import { useHistory } from 'react-router-dom';
import EquipeCad from '../EquipeCad/EquipeCad';
import { excluiUsuario, listaEquipe, listaOperacao, requestService, removerLoja, incluirLoja, patchUsuariosAcessosAgendamentos, gerarApikey } from '../../../../../Utils/Services';

const Equipe: React.FC = () => {

  const history = useHistory();
  const [showDetalhes, setShowDetalhes] = useState(false);
  const [arrayOperacoes, setArrayOperacoes] = useState<any>([]);
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [operacaopk, setOperacaopk] = useState("");
  const [perfil, setPerfil] = useState(localStorage.getItem("perfil"));
  const [textToast, setTextToast] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [cpf, setCpf] = useState("");
  const [showResetSenha, setShowResetSenha] = useState(false);
  const [showExcluirUsuario, setShowExcluirUsuario] = useState(false);
  const [showSucesso, setShowSucesso] = useState(false);
  const [showSucessoKey, setShowSucessoKey] = useState(false);
  const [showErro, setShowErro] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [lojaInserir, setLojaInserir] = useState("");
  const [usuario, setUsuario] = useState<any>();
  const [showGerarApikey, setShowGerarApikey] = useState(false);

  const [mostartAlerta] = useIonAlert();
  const [mostrarToast, fecharToast] = useIonToast();

  function cpf_mask(v: string) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  function funcRemoverLoja(usuario: string, loja: string) {

    console.log(usuario, loja);
    return fetch(removerLoja.url.replace("{cpf}", usuario.replace(/#/g, "%23")),
      {
        method: removerLoja.method,
        headers: [
          ["token", localStorage.getItem("token") || ""]
        ],
        credentials: 'include',
        body: JSON.stringify({ 'loja': loja })
      });
  }

  function funcIncluirLoja(usuario: string, loja: string) {

    console.log(usuario, loja);
    return fetch(incluirLoja.url.replace("{cpf}", usuario.replace(/#/g, "%23")),
      {
        method: incluirLoja.method,
        headers: [
          ["token", localStorage.getItem("token") || ""]
        ],
        credentials: 'include',
        body: JSON.stringify({ 'loja': loja })
      });
  }

  useIonViewWillEnter(() => {
    if (chamadaRealizada) {
      carregarUsuarios();
    }
  })

  const loadItens = () => {

    if (!chamadaRealizada) {
      setChamadaRealizada(true);
      carregarUsuarios();
    }

    if (arrayOperacoes === undefined || arrayOperacoes.length === 0) {
      return (
        <IonCard key="primeira" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonCardHeader id="primeira" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
            <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aqui aparecem os usuários da equipe</IonCardTitle>
            <IonCardSubtitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCardSubtitle>
            <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonLabel>
          </IonCardHeader>
          <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          </IonCardContent>
        </IonCard>
      );
    }

    return arrayOperacoes.map((value: any, index: any, arr: any) =>

      <div style={{ width: '90%', margin: 'auto', marginTop: '10px', marginBottom: '10px', background: '#ffffff', borderRadius: '25px' }}>
        <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><b>{value.nome}</b></IonCol></IonRow>
          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonItem lines='full' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Dados</IonLabel>
              </IonItem>

              <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon icon={documentLock} slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <IonLabel className="equipeTexto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <p style={{ fontSize: '10px' }}>Perfil</p>
                  {value.perfil == "Cliente" ? "Administrador" : "Usuário"}</IonLabel>
              </IonItem>
              <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon icon={idCard} slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <IonLabel className="equipeTexto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <p style={{ fontSize: '10px' }}>Documento</p>
                  {cpf_mask(value.cpf)}</IonLabel>
              </IonItem>
              <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon icon={mail} slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <IonLabel className="equipeTexto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <p style={{ fontSize: '10px' }}>E-mail</p>
                  {value.email}</IonLabel>
              </IonItem>
              <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon icon={call} slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                <IonLabel className="equipeTexto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <p style={{ fontSize: '10px' }}>Telefone</p>
                  {value.telefone}</IonLabel>
              </IonItem>

            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonItem lines='full' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Acessos</IonLabel>
              </IonItem>

              <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Agendamento</IonLabel>
                <IonSelect value={value?.acessos?.agendamento || 'sem acesso'} interface='alert' disabled={perfil != "Cliente" || value.cpf == localStorage.getItem("cpf")} onIonChange={(e) => { atualizaAcessoAgenda(value.cpf, e.detail.value); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonSelectOption value="sem acesso" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Sem acesso</IonSelectOption>
                  <IonSelectOption value="leitura" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Leitura</IonSelectOption>
                  <IonSelectOption value="edicao" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Edição</IonSelectOption>
                </IonSelect>
              </IonItem>

              <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Chave Integração</IonLabel>
                <IonButton size="small" fill='solid' shape="round" color="tertiary" expand='block' disabled={!(value.cpf == localStorage.getItem("cpf"))} onClick={() => { setCpf(value.cpf); setMensagem("Deseja gerar apikey? Caso já tenha outra apikey a mesma será desativa."); setShowGerarApikey(true); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Gerar Key</IonButton>
              </IonItem>
            </IonCol>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
              <IonItem lines='full' hidden={!(value && value.lojas && value.lojas.length > 0)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Lojas</IonLabel>
                <IonSelect hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 0) && value.cpf != localStorage.getItem("cpf") ? false : true} name='Lojas' placeholder='Inserir' title='Lojas' multiple={false} cancelText="Cancel" okText="Ok" onIonChange={(e) => {
                  console.log(e);
                  mostartAlerta({
                    backdropDismiss: false,
                    header: 'Incluir Loja',
                    message: 'Realizar <strong>inclusão</strong> da loja?',
                    buttons: [
                      {
                        text: 'Cancelar',
                        role: 'cancel',
                      },
                      {
                        text: 'Confirmar',
                        cssClass: 'primary',
                        handler: () => {
                          setShowLoading(true);
                          let retorno = funcIncluirLoja(value.cpf, e.detail.value.clienteLojaId);
                          if (retorno) {
                            retorno?.then(async (res) => {
                              let body = await res.json();
                              if (res.status === 200) {
                                if (value.lojas) {
                                  value.lojas?.push({ clienteLojaId: e.detail.value.clienteLojaId, clienteLojaNome: e.detail.value.clienteLojaNome });
                                }
                                else {
                                  value.lojas = [{ clienteLojaId: e.detail.value.clienteLojaId, clienteLojaNome: e.detail.value.clienteLojaNome }];
                                }
                                //valorLoja.clienteLojaNome = "";
                                mostrarToast({
                                  duration: 2000,
                                  position: 'middle',
                                  buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                  message: 'Loja incluida com sucesso.'
                                });
                              }
                              else {
                                mostrarToast({
                                  duration: 2000,
                                  position: 'middle',
                                  buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                  message: body.message || 'Erro ao tentar incluir.'
                                });
                              }
                            }).catch(() => {
                              mostrarToast({
                                duration: 2000,
                                position: 'middle',
                                buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                message: 'Erro ao tentar incluir.'
                              });
                            }).finally(() => {
                              setShowLoading(false);
                            });
                          }
                          else {
                            mostrarToast({
                              duration: 2000,
                              position: 'middle',
                              buttons: [{ text: 'ok', handler: () => fecharToast() }],
                              message: 'Erro ao tentar incluir.'
                            });
                            setShowLoading(false);
                          }
                          return true;
                        }
                      }
                    ],
                    onDidDismiss: (e) => console.log('did dismiss'),
                  });
                } } onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
                  {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any) => (
                    <IonSelectOption value={{ clienteLojaId: valor.clienteLojaId, clienteLojaNome: valor.clienteLojaNome }} onSelect={() => console.log("selecionado")} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{valor.clienteLojaNome}</IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>
              {value.lojas?.map((valorLoja: any, indiceLoja: any, arrLoja: any) => (
                <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonIcon icon={storefront} slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                  <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{valorLoja.clienteLojaNome}</IonLabel>
                  <IonIcon icon={trash} color="danger" onClick={() => mostartAlerta({
                    backdropDismiss: false,
                    header: 'Remover Loja',
                    message: 'Realizar <strong>remoção</strong>?',
                    buttons: [
                      {
                        text: 'Cancelar',
                        role: 'cancel',
                      },
                      {
                        text: 'Remover',
                        cssClass: 'primary',
                        handler: () => {
                          setShowLoading(true);
                          let retorno = funcRemoverLoja(value.cpf, valorLoja.clienteLojaId);
                          if (retorno) {
                            retorno?.then(res => {
                              if (res.status === 200) {
                                valorLoja.clienteLojaNome = "";
                                mostrarToast({
                                  duration: 2000,
                                  position: 'middle',
                                  buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                  message: 'Loja removida com sucesso.'
                                });
                              }
                              else {
                                mostrarToast({
                                  position: 'middle',
                                  buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                  message: 'Erro ao tentar remover.'
                                });
                              }
                            }).catch(() => {
                              mostrarToast({
                                position: 'middle',
                                buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                message: 'Erro ao tentar remover.'
                              });
                            }).finally(() => {
                              setShowLoading(false);
                            });
                          }
                          else {
                            mostrarToast({
                              position: 'middle',
                              buttons: [{ text: 'ok', handler: () => fecharToast() }],
                              message: 'Erro ao tentar remover.'
                            });
                            setShowLoading(false);
                          }
                          return true;
                        }
                      }
                    ],
                    onDidDismiss: (e) => console.log('did dismiss'),
                  })}
                  hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 0) && value.cpf != localStorage.getItem("cpf") ? false : true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                  ></IonIcon>
                </IonItem>
              ))}
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonItem lines="none" style={{ borderRadius: '25px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
          <IonButton size="small" fill='outline' shape="round" color="tertiary" slot="start" disabled={perfil == "Usuário" || value.perfil == "Cliente"} hidden={true} onClick={() => { setCpf(value.cpf); setMensagem("Deseja realmente <strong>reiniciar</strong> a senha do " + value.nome + "?"); setShowResetSenha(true); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Alterar senha</IonButton>
          <IonButton size="small" fill='outline' shape="round" color="tertiary" slot="start" disabled={perfil == "Usuário" || value.cpf == localStorage.getItem("cpf")} onClick={() => { setUsuario(value); setShowDetalhes(true); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Alterar conta</IonButton>
          <IonButton size="small" fill='solid' shape="round" color="tertiary" slot="end" className="botaoExcluir" disabled={perfil == "Usuário" || value.cpf == localStorage.getItem("cpf")} onClick={() => { setCpf(value.cpf); setMensagem("Deseja realmente excluir a conta do " + value.nome + "?"); setShowExcluirUsuario(true); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Excluir conta</IonButton>
        </IonItem>
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          message={'Registrando...'}

        />
      </div>
    );

  }

  function carregarUsuarios() {
    const consultar = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      const resp = await fetch(listaEquipe.url,
        {
          method: listaEquipe.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      let equipe = await resp.json();
      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }
      else {
        setArrayOperacoes(equipe.Items.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1));
        //setArrayOperacoes(equipe.Items);
        if (equipe.LastEvaluatedKey) {
          setOperacaopk(equipe.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setOperacaopk("");
          setDesabilitarInfiniteScroll(true);
        }
      }
    }
    consultar();
  }

  async function carregarMaisUsuarios($event: CustomEvent<void>) {

    await carregarMaisUsuariosChamada().then(() => {
      console.log("terminou resultados");//($event.target as HTMLIonInfiniteScrollElement).complete();
    });
    /*
        const consultar = async () =>{
          const resp = await fetch(listaOperacao.url,
            {
              method: listaOperacao.method,
              credentials: 'include'
            });
          const operacoes = await resp.json().then((operacoes) => {
            for (let i = 0; i < operacoes.Items.length; i++){
              arrayOperacoes.push(operacoes.Items[i]);
            }
          })
        }
        await consultar().then(() => {($event.target as HTMLIonInfiniteScrollElement).complete();});
    */
    ($event.target as HTMLIonInfiniteScrollElement).complete();


  }

  async function carregarMaisUsuariosChamada() {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    const res: Response = await fetch(listaOperacao.url + "?pk=" + operacaopk,
      {
        method: listaOperacao.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    await res
      .json()
      .then(async (operacoes) => {
        console.log(arrayOperacoes.length);
        for (let i = 0; i < operacoes.Items.length; i++) {
          console.log("resultados");
          arrayOperacoes.push(operacoes.Items[i]);
        }
        console.log(arrayOperacoes.length);
        if (operacoes.LastEvaluatedKey) {
          setOperacaopk(operacoes.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setOperacaopk("");
          setDesabilitarInfiniteScroll(true);
          console.log("finalizou");
        }
        //($event.target as HTMLIonInfiniteScrollElement).complete();
      })
      .catch(err => console.error(err));

    if (res.status === 400 || res.status === 401) history.replace("/login/");
  }

  async function closeModal() {
    setUsuario(null);
    setShowDetalhes(false);
    carregarUsuarios();
  }

  async function closeModalSimple() {
    setUsuario(null);
    setShowDetalhes(false);
  }

  function doRefresh(event: any) {
    // console.log('Begin async operation');
    //carregarOperacoes();
    // console.log("refresh" + statusOperacao);
    carregarUsuarios();
    setTimeout(() => {
      // console.log('Async operation has ended');
      event.detail.complete();
    }, 1200);
  }

  async function atualizaAcessoAgenda(usuario: any, perfil: any) {
    console.log(usuario, perfil);
    requestService(patchUsuariosAcessosAgendamentos.url.replace("{id}", usuario), {
      method: patchUsuariosAcessosAgendamentos.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify({ "agendamento": perfil }),
      credentials: 'include'
    },
      null,
      (response: any) => {
        //carregarUsuarios();
      },
      (error: any) => {
        console.log(error);
      });
  }

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon slot="icon-only" icon={people} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            </IonButton>
          </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Equipe</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="equipecontent" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
        <IonRefresher slot="fixed" onIonRefresh={doRefresh} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonRefresherContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonRefresherContent>
        </IonRefresher>
        <IonModal isOpen={showDetalhes} onDidDismiss={() => { setShowDetalhes(false); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <EquipeCad usuario={usuario} closeAction={closeModal} closeActionSimple={closeModalSimple}></EquipeCad>
        </IonModal>
        <IonButton hidden={true} onClick={() => { setUsuario(null); setShowDetalhes(true); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Novo</IonButton>
        <IonFab hidden={perfil == "Usuário"} vertical="top" horizontal="end" slot="fixed" edge placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonFabButton color="tertiary" onClick={() => setShowDetalhes(true)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
            <IonIcon color="light" icon={add} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
          </IonFabButton>
        </IonFab>
        {loadItens()}
        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisUsuarios(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais usuários]..." placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInfiniteScrollContent>
        </IonInfiniteScroll>

        <IonAlert
          isOpen={showResetSenha}
          onDidDismiss={() => setShowResetSenha(false)}
          header={'Reset de Senha'}
          message={mensagem}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {
                // requestService(resetSenhaUsuario.url.replace("{cpf}", cpf), {
                //   method: resetSenhaUsuario.method,
                //   headers: [["token", localStorage.getItem("token") || ""]],
                //   credentials: 'include'
                // },
                //   history,
                //   (response: any) => {
                //     setTextToast(response.message);
                //     setShowSucesso(true);
                //   },
                //   (error: any) => {
                //     setTextToast(error.message);
                //     setShowErro(true);
                //   });
              }
            }
          ]}
        />

        <IonAlert
          isOpen={showGerarApikey}
          onDidDismiss={() => setShowGerarApikey(false)}
          header={'Geração de APikey'}
          message={mensagem}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {
                requestService(gerarApikey.url.replace("{cpf}", cpf), {
                  method: gerarApikey.method,
                  headers: [["token", localStorage.getItem("token") || ""]],
                  credentials: 'include'
                },
                  history,
                  (response: any) => {
                    carregarUsuarios();
                    setTextToast(response.message);
                    setShowSucessoKey(true);
                  },
                  (error: any) => {
                    setTextToast(error.message);
                    setShowErro(true);
                  });
              }
            }
          ]}
        />

        <IonAlert
          isOpen={showExcluirUsuario}
          onDidDismiss={() => setShowExcluirUsuario(false)}
          header={'Exclusão de Usuário'}
          message={mensagem}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {
                requestService(excluiUsuario.url.replace("{cpf}", cpf), {
                  method: excluiUsuario.method,
                  headers: [["token", localStorage.getItem("token") || ""]],
                  credentials: 'include'
                },
                  history,
                  (response: any) => {
                    carregarUsuarios();
                    setTextToast(response.message);
                    setShowSucesso(true);
                  },
                  (error: any) => {
                    setTextToast(error.message);
                    setShowErro(true);
                  });
              }
            }
          ]}
        />

        <IonAlert
          isOpen={showSucesso}
          onDidDismiss={() => setShowSucesso(false)}
          header={'Sucesso'}
          message={textToast}
          buttons={['OK']}
        />

        <IonAlert
          isOpen={showSucessoKey}
          onDidDismiss={() => setShowSucessoKey(false)}
          header={'CHAVE GERADA'}
          message={textToast}
          backdropDismiss={false}
          buttons={[{
            text: 'COPIAR CHAVE',
            cssClass: 'alert-button-confirm',
            handler: () => {
              navigator.clipboard.writeText(textToast);
            },
          }]}
        />

        <IonAlert
          isOpen={showErro}
          onDidDismiss={() => setShowErro(false)}
          header={'Erro'}
          message={textToast}
          buttons={['OK']}
        />
      </IonContent>
    </IonPage>
  );
};

export default Equipe;
